// @store
import { useSidebarStore } from "../../store/useSidebarStore"

// @icons
import { Icon } from "../atoms/Icon"

interface NavItemProps {
  icon: React.ReactNode
  label?: string
  href?: string | any
  onClick?: () => void
  active?: boolean
  isDashboard?: boolean
  [key: string]: any
}

export const NavItem = ({
  icon,
  label,
  href,
  onClick,
  active,
  isDashboard,
  ...props
}: NavItemProps) => {
  const isExpanded = useSidebarStore((state) => state.isExpanded)

  const Component = isDashboard ? 'button' : href ? 'a' : 'button';
  const componentProps = isDashboard ? { onClick } : href ? { href } : { onClick }
  return (
    <Component
      {...componentProps}
      {...props}
      className={`
          flex items-center gap-3 lg:p-2 p-0 rounded-lg
          transition-all duration-200
          ${active ? 'bg-primary-50 text-primary-600 dark:text-white' : 'hover:bg-gray-50 text-gray-700 dark:hover:bg-gray-600 dark:text-white'}
          ${isExpanded ? 'w-full bg-white' : 'w-8 lg:w-12 '}
        `}
    >
      <Icon icon={icon} active={active} />
      {isExpanded && label && (
        <span className="font-medium whitespace-nowrap">{label}</span>
      )}
    </Component>
  )
}